exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Footer__root___2r2Uu {\n  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0)), to(rgba(0, 0, 0, .33)));\n  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, .33));\n  color: rgba(255, 255, 255, .9);\n  font-size: 13px;\n  padding: 20px 15px 15px;\n  position: absolute;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.Footer__uploader___3S6PS {\n  margin-right: 12px;\n}\n\n.Footer__download___3-tbL, .Footer__uploader___3S6PS a {\n  color: white;\n}\n\n.Footer__download___3-tbL:hover, .Footer__uploader___3S6PS a:hover {\n  color: #d6dee7;\n}\n\n.Footer__right___13a7c {\n  margin-left: auto;\n  padding-left: 24px;\n}\n", ""]);

// exports
exports.locals = {
	"root": "Footer__root___2r2Uu",
	"uploader": "Footer__uploader___3S6PS",
	"download": "Footer__download___3-tbL",
	"right": "Footer__right___13a7c"
};